import { Injectable } from '@angular/core';
import { startOfDay } from 'date-fns';
import { parseDateFromMW } from '~app/shared/functions/utils/utils.function';
import { IAssignment } from '~app/shared/interfaces/assignment.interface';
import { IGetCrewAssignmentsResponse } from '~app/shared/services/mw/interfaces/GetCrewAssignments.interface';
import { IBeneficiaryContact } from '../mw/interfaces/GetCrewMemberProfile.interface';
import { IListSearchPayload } from '~app/shared/models/utils-service.interface';
@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  public getClosestAssignment(assignments: IGetCrewAssignmentsResponse): IAssignment {
    const futureAssignments = assignments.payload.assignments
      .filter(assignment => {
        const assignmentDate = parseDateFromMW(assignment.signonDate);
        const today = startOfDay(new Date());
        if (assignmentDate < today) return false;
        return true;
      })
      .sort((a, b) => {
        const aSignonDate = parseDateFromMW(a.signonDate);
        const bSignonDate = parseDateFromMW(b.signonDate);
        if (aSignonDate > bSignonDate) return 1;
        if (aSignonDate < bSignonDate) return -1;
        return 0;
      });

    return futureAssignments[0];
  }

  public refactorContact(
    contact: IBeneficiaryContact,
    contactType: 'S' | 'P',
    contactKind: 'E' | 'B',
    percentage?: number,
  ): IBeneficiaryContact {
    const isBeneficiariContact = contactKind === 'B';
    if (isBeneficiariContact && contactType === 'P') {
      contact.percentageAllocated = percentage - 0;
    } else if (isBeneficiariContact && contactType === 'S') {
      contact.percentageAllocated = 100 - percentage;
    }
    Object.keys(contact).forEach((property: string) => {
      if (typeof contact[property] === 'string') {
        contact[property] = contact[property].trim() === '' ? undefined : contact[property].trim();
      }
    });
    return {
      ...contact,
      contactType,
      emergencyOrBeneficiary: contactKind,
      email: contact.emailAddress,
    };
  }

  public searchValueOnListAndSetValue(searchPayload: IListSearchPayload): void {
    const { formGroup, optionList, key, keyValue } = searchPayload;
    // Allow JDE lowercase or uppercase strings to be mapped to a valid option in the list.
    let mappedValue = '';
    if (keyValue) {
      mappedValue = optionList.find(item => item.value.toLowerCase() === keyValue.toLowerCase())?.value ?? '';
    }
    formGroup.controls[key].setValue(mappedValue);
  }
}
